<template>
    <div class="posfinder-screen__map" :class="wrapperClass" ref="wrapper">

        <div class="posfinder-screen__map-overlay">
            <div class="posfinder-screen__map-overlay-content"></div>
        </div>

        <!-- Google Map Inject -->
        <div class="posfinder-screen__map-hook" ref="gmap" @click="handleClick"></div>

        <!-- Clustered Pins get injected into the Google Map -->
        <ClusterPin v-if="map && cluster.locations.length > 1"
                    v-for="(cluster,i) in clusteredResults" :key="'c-'+i"
                    :cluster="cluster"
                    :map="map"
        />

        <!-- Map Pins get injected into the Google Map -->
        <LocationPin v-if="map"
                     v-for="(location,i) in unclusteredResults" :key="'uc-'+i"
                     :location="location"
                     :map="map"
                     @click="updateFocus(location)"
        />
        <Spinner :fixed="false" :loading="loading > 0"/>
    </div>
</template>

<script>
import gMap from "../scripts/gMap";

import {mapState} from 'vuex';
import {clusterLocations} from "../scripts/gmap/cluster";
import LocationPin from "./partials/LocationPin";
import ClusterPin from "./partials/ClusterPin";
import Spinner from "./partials/Spinner";

export default {
    name: "Map",
    components: {
        Spinner,
        ClusterPin,
        LocationPin
    },
    props: {
        initial: Boolean,
        loading: Number,
        apikey: String,
    },
    data() {
        return {
            map: null,
            points: []
        }
    },
    watch: {
        activeResults: 'alignMap'
    },
    computed: {
        ...mapState({
            openResult: 'resultOpen',
            openFilter: 'filterOpen',
            formOpen: 'formOpen',
            activeResults: 'results'
        }),
        wrapperClass() {
            let classes = [];
            if (this.openFilter && this.formOpen) {
                classes.push('is-blurred')
            } else if (this.initial) {
                classes.push('is-inactive');
            } else if (this.openResult) {
                classes.push('show-results');
            }
            return classes.join(' ');
        },
        zoomLevel() {
            if (!this.map || !this.map.map) {
                return 48;
            }
            return this.map.map.zoom;
        },
        unclusteredResults() {
            const list = [];
            this.clusteredResults.forEach(c => {
                if (c.locations.length === 1) {
                    list.push(c.locations[0]);
                } else {
                    c.locations.forEach(l => {
                        if (l.focus) {
                            list.push(l);
                        }
                    });
                }
            });
            return list;
        },
        clusteredResults() {
            return clusterLocations(this.activeResults, this.zoomLevel);
        },
    },
    mounted() {
        gMap(this.$refs.gmap, this.apikey ,map => {
            map.mount();
            this.map = map;
        });
    },
    methods: {
        alignMap() {
            this.map.autoCenter(this.activeResults.map(l => l.coords));
        },
        updateFocus(location) {
            this.$store.commit('clearResultFocus');
            this.$store.commit('setResultFocus', location);
        },
        handleClick(event) {
            if (event.target.classList.toString().indexOf('posfinder-screen') === -1) {
                this.$store.commit('clearResultFocus');
                return;
            }
            event.stopPropagation()
        }
    }
}
</script>
